module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "stretch-columns",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "new-info-table",
    attrs: {
      "md6": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "homepage-tool elevation-0 black--text",
    attrs: {
      "color": "white"
    }
  }, [_c('h5', {
    staticClass: "pa-4",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400"
    }
  }, [_vm._v("New users")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.topusersHeaders,
      "items": _vm.topusers,
      "hide-actions": "",
      "loading": _vm.loadingUsers
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "avatar-cell"
        }, [_c('img', {
          staticClass: "avatar img-avatar",
          attrs: {
            "src": props.item.avatar
          }
        })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstname) + " " + _vm._s(props.item.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.companylegalname))]), _vm._v(" "), _c('td', [_c('a', {
          style: ({
            color: _vm.styles.general.theme_color_light
          }),
          attrs: {
            "href": props.item.email
          }
        }, [_vm._v(_vm._s(props.item.email))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.jobtitle))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "new-users-table",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "md6": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "homepage-tool elevation-0 black--text",
    attrs: {
      "color": "white"
    }
  }, [_c('h5', {
    staticClass: "pa-4",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400"
    }
  }, [_vm._v("New Companies")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.topcompaniesHeaders,
      "items": _vm.newUnverifiedCompanies,
      "hide-actions": "",
      "no-data-text": "All company submissions have been approved"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "avatar-cell"
        }, [_c('img', {
          staticClass: "avatar img-avatar",
          attrs: {
            "src": props.item.companylogo
          }
        })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.companylegalname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstname) + " " + _vm._s(props.item.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.submitdate))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0814f1c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Index/block.1.vue
// module id = 1217
// module chunks = 0 1